module.exports = __webpack_public_path__ + "img/sdm1.fa118a96.jpg";